import { useCallback, useState } from 'react';
import ProductSearchInput from './ProductSearchInput';

/**
 * The "Barcode / Search" box above the line items table. Picking a result, or
 * scanning a barcode, adds it as a new line; when no result has the typed text
 * as a barcode, "Add item" adds a new line with that text as its barcode. The
 * box then clears for the next item.
 */
export default function LineItemSearchBar({ onItemSelected, onCreateNew, onBarcodeScan }) {
  const [text, setText] = useState('');

  const handleItemSelected = useCallback(
    (item) => {
      setText('');
      onItemSelected(item);
    },
    [onItemSelected],
  );

  const handleCreateNew = useCallback(
    (code) => {
      setText('');
      onCreateNew(code);
    },
    [onCreateNew],
  );

  return (
    <ProductSearchInput
      value={text}
      onChangeText={setText}
      onItemSelected={handleItemSelected}
      onCreateNew={handleCreateNew}
      productType="product"
      onBarcodeScan={onBarcodeScan}
      label="Barcode / Search"
      showNewItemHint={false}
    />
  );
}
